export const USER_ACCESS_TOKEN = 'admin-token';
export const USER_REFRESH_TOKEN = 'refresh-token';
export const USER_ID_COOKIE_NAME = 'admin_UUID';
